export default "__VITE_ASSET__DI6ccobg__"